// dev-kit — ponto ÚNICO de registro das features customizadas no frontend.
// Os arquivos do core importam SÓ daqui (1 linha cada). Assim, adicionar novas
// features no futuro NÃO toca mais no core: basta estender este arquivo.
//
// Hooks no core (1 linha cada — ver docs/CORE_TOUCHPOINTS.md):
//   store/index.js                        -> ...devKitStoreModules
//   routes/dashboard/dashboard.routes.js  -> ...devKitRoutes
//   i18n/locale/en/index.js               -> ...devKitLocaleEn
//   i18n/locale/pt_BR/index.js            -> ...devKitLocalePtBR
//   components-next/sidebar/Sidebar.vue   -> ...devKitMenuItems(t, accountScopedRoute)

import reminders from '../store/modules/reminders';
import pipelines from '../store/modules/pipelines';
import DevKitConversationPipeline from '../routes/dashboard/pipelines/DevKitConversationPipeline.vue';
import remindersRoutes from '../routes/dashboard/reminders/reminders.routes';
import pipelinesRoutes from '../routes/dashboard/pipelines/pipelines.routes';
import remindersLocaleEn from '../i18n/locale/en/reminders.json';
import pipelineLocaleEn from '../i18n/locale/en/pipeline.json';
import remindersLocalePtBR from '../i18n/locale/pt_BR/reminders.json';
import pipelineLocalePtBR from '../i18n/locale/pt_BR/pipeline.json';

// Vuex modules (namespaced) das features.
export const devKitStoreModules = {
  reminders,
  pipelines,
};

// Rotas do dashboard das features.
export const devKitRoutes = [
  ...remindersRoutes.routes,
  ...pipelinesRoutes.routes,
];

// i18n — `en` é a base; `pt_BR` cobre as features deste fork (CLAUDE.md exige
// en + pt_BR). Demais idiomas seguem via comunidade (AGENTS.md).
export const devKitLocaleEn = {
  ...remindersLocaleEn,
  ...pipelineLocaleEn,
};

export const devKitLocalePtBR = {
  ...remindersLocalePtBR,
  ...pipelineLocalePtBR,
};

// Itens da sidebar (definições no dev-kit). Exportados individualmente para o
// Sidebar.vue posicioná-los: Pipeline logo após "Conversas" e Lembretes logo após
// "Relatórios". `t`/`accountScopedRoute` vêm do escopo do Sidebar.vue.
export const devKitPipelineMenuItem = (t, accountScopedRoute) => ({
  name: 'Pipeline',
  label: t('PIPELINES.NAV'),
  icon: 'i-lucide-workflow',
  to: accountScopedRoute('pipelines_index'),
  activeOn: ['pipelines_index', 'pipeline_board'],
});

export const devKitReminderMenuItem = (t, accountScopedRoute) => ({
  name: 'Reminders',
  label: t('REMINDERS.NAV'),
  icon: 'i-lucide-alarm-clock',
  to: accountScopedRoute('reminders_index'),
  activeOn: ['reminders_index'],
});

// Compat: lista com os dois (caso algo ainda use o spread).
export const devKitMenuItems = (t, accountScopedRoute) => [
  devKitPipelineMenuItem(t, accountScopedRoute),
  devKitReminderMenuItem(t, accountScopedRoute),
];

// Widgets de painel/conversa plugados no core (importados de 1 linha cada lá).
// DevKitConversationPipeline -> ContactPanel.vue (logo após <ContactInfo />).
export { DevKitConversationPipeline };
